<template>
  <div>
    <div class="sidebar-backdrop" @click="close($event)" v-if="isActive"></div>
    <transition name="slide">
      <div v-if="isActive" class="sidebar-panel">
        <slot>
          <div class="sidebar-panel-content">
            <div class="close-btn-container">
              <span class="material-icons" @click="close($event)"> close </span>
            </div>
            <div class="product-configuration-container">
              <p class="product-configuration-title">{{ modalTitle }}</p>
              <div v-for="(option, index) in modalOptions" :key="index">
                <div
                  v-if="
                    option.Position &&
                      option.Position[0] &&
                      option.Position[0].IsMultiSelectAllowed
                  "
                  class="position"
                >
                  <div v-if="index === 0" class="position__header">
                    <div
                      v-html="headerDescription"
                      class="position__header__placement"
                    ></div>
                    <div v-if="headerImage" class="position__header__image">
                      <img
                        class="responsive-image header-image"
                        :src="headerImage"
                      />
                    </div>
                  </div>
                  <PositionCard
                    :option-value="option"
                    @select-position="selectPosition"
                    v-if="isValidOption(option)"
                    :index="index"
                  ></PositionCard>
                </div>

                <div
                  v-else-if="
                    option &&
                      option.Position &&
                      option.Position[0] &&
                      !option.Position[0].IsMultiSelectAllowed
                  "
                  class="position"
                >
                  <div v-if="index === 0" class="position__header">
                    <div
                      v-html="headerDescription"
                      class="position__header__placement"
                    ></div>
                    <div v-if="headerImage" class="position__header__image">
                      <img
                        class="responsive-image header-image"
                        :src="headerImage"
                      />
                    </div>
                  </div>
                  <div
                    class="clearBtn"
                    v-if="showClearButton(index)"
                    @click="removeCutoutOption(option)"
                  >
                    Clear Selection
                  </div>
                  <SinglePositionCard
                    :option-value="option"
                    @select-position="selectPosition"
                    v-if="isValidOption(option)"
                  ></SinglePositionCard>
                </div>

                <div v-else>
                  <div
                    class="clearBtn"
                    v-if="showClearButton(index) && isCustomOptional "
                    @click="removeOption(option)"
                  >
                    Clear Selection
                  </div>
                  <div
                    class="clearBtn"
                    v-if="showClearButton(index) && !isCustomOptional && (dependentProperty == 'TableLengthId' || dependentProperty == 'TableBaseFinishId' ) "
                    @click="removeOption(option)"
                  >                    
                  </div>
                  <div
                    class="clearBtn"
                    v-if="showClearButton(index) && !isCustomOptional && !(dependentProperty == 'TableLengthId' || dependentProperty == 'TableBaseFinishId' ) "
                    @click="removeOption(option)"
                  >
                    Clear Selection
                  </div>
                  <ConfigCard
                    :option-value="option"
                    :index="index"
                    v-if="isValidOption(option)"
                    :selected-index="getSelectedIndex(option, index)"
                    :current-index="currentIndex"
                    @select-option="selectOption"
                    :isPart="isPart"
                  />
                </div>
              </div>
              <!-- Custom HPL Color Modal -->
              <ModalTextField v-if="this.getIsCustomHPL" ref="TextFieldModal" />
            </div>
          </div>
        </slot>
        <button
          class="apply-selection-btn"
          v-if="showApplyButton()"
          @click="
            apply();
            getproductVariantCharacteristics($event);
          "
        >
          Apply Selection
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
import PositionCard from "./ModalOptionPositionCard";
import SinglePositionCard from "./ModalOptionSinglePositionCard";
import ConfigCard from "./ModalOptionCard";
import ModalTextField from "./ModalOptionTextField";
import { mapGetters } from "vuex";

export default {
  props: {
    isActive: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    modalOptions: {
      type: Array,
      default: function() {
        return [];
      }
    },
    modalTitle: {
      type: String,
      default: function() {
        return "";
      }
    },
    headerDescription: {
      type: String,
      default: function() {
        return "";
      }
    },
    dependentProperty: {
      type: Array,
      default: function() {
        return [];
      }
    },
    isPart: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    sectionId: {
      type: String,
      default: function() {
        return "";
      }
    },
    headerImage: {
      type: String,
      default: function() {
        return "";
      }
    },
    isOptional: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    optionindexinasection: {
      type: Number,
      default: function() {
        return null;
      }
    }
  },
  data() {
    return {
      selectedIndex: null,
      currentIndex: null,
      selectedCutoutPositions: {},
      selectedRulesKey: "",
      isPositionOption: false,
      nullCustomHPLData: {
        Id: null,
        RulesKey: null,
        ColorName: null,
        ColorNumber: null,
        Manufacturer: null
      },
      isCustomOptional: true
    };
  },
  components: {
    PositionCard,
    ConfigCard,
    SinglePositionCard,
    ModalTextField
  },
  computed: {
    ...mapGetters("enhancedproduct", [
      "getSelectedOptions",
      "getSections",
      "getVariantCode",
      "getIsCustomHPL",
      "getIsOtherCustomHPL",
      "getcustomHPLFormData",
      "getcustomHPLData"
    ]),
    ...mapGetters("enhancedBom", ["getBomSourceOfTruth"])
  },
  methods: {
    close($event) {
      // Clear cutout positions validation state
      let modalOpts = Array.from(this.modalOptions);
      if (modalOpts) {
        // if : clicked on the backdrop do not save/submit form
        // else: Submit the custom hpl form when we click on X icon and close the menu
        if (this.getIsCustomHPL) {
          if ($event.target.classList.contains("sidebar-backdrop")) {
            this.$store.dispatch("enhancedproduct/setIsCustomHPL", false);
            this.$store.dispatch("enhancedproduct/setIsOtherCustomHPL", false);
            this.$store.dispatch(
              "enhancedproduct/DeleteSelectedOptionCustomHPL",
              this.getcustomHPLData
            );
          } else {
            this.$refs.TextFieldModal.submitHandler();
          }
        }
        for (let i = 0; i < modalOpts.length; i++) {
          if (
            modalOpts[i] &&
            modalOpts[i].Position &&
            modalOpts[i].Position.length > 0
          ) {
            for (let j = 0; j < modalOpts[i].Position.length; j++) {
              this.$store
                .dispatch("enhancedproduct/setCutoutPositionValidation", {
                  rulesKey: modalOpts[i].RulesKey,
                  sectionId: modalOpts[i].EnhancedSectionId,
                  checked: false,
                  positionKey: modalOpts[i].Position[j].PositionValue,
                  value: modalOpts[i].Value
                })
                .then(() => {
                  this.$emit("close");
                });
            }
          } else {
            this.$emit("close");
          }
        }
      } else {
        this.$emit("close");
      }
    },
    isValidOption(option) {
      let _valuesCount = 0;
      const _tmpSelectedOptions = this.getSelectedOptions;
      if (
        option.DependentPropertyValues &&
        option.DependentPropertyValues.length > 0
      ) {
        for (let i = 0; i < option.DependentPropertyValues.length; i++) {
          if (option.DependentPropertyValues[i]) {
            for (const key in _tmpSelectedOptions) {
              for (const optionKey in _tmpSelectedOptions[key]) {
                if (
                  _tmpSelectedOptions[key][optionKey] &&
                  _tmpSelectedOptions[key][optionKey].Value ==
                    option.DependentPropertyValues[i]["Value"] &&
                  _tmpSelectedOptions[key][optionKey].RulesKey ==
                    option.DependentPropertyValues[i]["Key"]
                ) {
                  _valuesCount++;
                }
              }
            }
          }
        }
        if (_valuesCount == option.DependentPropertyValues.length) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    // It takes the dropdown options as input, and checks if it has Dependent Property. If so if it loops through all the DependentPropertyValues and checks through the selected options and filters them.
    filterOptionValuesByDependentProperty(options) {
      const _tmpSelectedOptions = this.getSelectedOptions;
      let filteredOptions = options.Values.filter(option => {
        let _valuesCount = 0;
        for (let i = 0; i < option.DependentPropertyValues.length; i++) {
          if (option.DependentPropertyValues[i]) {
            for (const key in _tmpSelectedOptions) {
              for (const optionKey in _tmpSelectedOptions[key]) {
                if (
                  _tmpSelectedOptions[key][optionKey] &&
                  _tmpSelectedOptions[key][optionKey].Value ==
                    option.DependentPropertyValues[i]["Value"] &&
                  _tmpSelectedOptions[key][optionKey].RulesKey ==
                    option.DependentPropertyValues[i]["Key"]
                ) {
                  _valuesCount++;
                }
              }
            }
          }
        }
        if (_valuesCount == option.DependentPropertyValues.length) {
          return true;
        } else {
          return false;
        }
      });
      return filteredOptions;
    },
    getproductVariantCharacteristics(event) {
      if (event && event.type == "click") {
        const partNames = this.getBomSourceOfTruth.filter(
          i => i.Value && i.Value.includes("-CUSTPNL") && i.IsProductVarientChar
        );
        if (partNames && partNames.length > 0) {
          let productVariantCharacteristics = {
            ISPRODUCTVARIANTWITHCHARS: "",
            VARIANT_CHARACTERISTICS: []
          };
          let currentCount = 1;
          const L5P_POSITION = "L5P_POSITION";
          const L5P_MODEL = "L5P_MODEL";
          const L5P_MANUFACTURER = "L5P_MANUFACTURER";

          for (const [key, value] of Object.entries(
            this.selectedCutoutPositions
          )) {
            if (value.RulesKey == "CustomPanelItems") {
              const manufacturer = key.substr(0, key.indexOf(" ") + 1);
              const positionMapping = {
                L: "Left Center",
                C: "Center",
                R: "Right Center"
              };
              const position = value.Position.map(x => positionMapping[x]);

              position.forEach(x => {
                if (currentCount == 1) {
                  productVariantCharacteristics.VARIANT_CHARACTERISTICS.push({
                    KEY: L5P_POSITION,
                    VALUE: x
                  });
                  productVariantCharacteristics.VARIANT_CHARACTERISTICS.push({
                    KEY: L5P_MODEL,
                    VALUE: key.substr(key.indexOf(" ") + 1)
                  });
                  productVariantCharacteristics.VARIANT_CHARACTERISTICS.push({
                    KEY: L5P_MANUFACTURER,
                    VALUE: manufacturer || "NA"
                  });
                  currentCount = ++currentCount;
                } else {
                  productVariantCharacteristics.VARIANT_CHARACTERISTICS.push({
                    KEY: `${L5P_POSITION}_${currentCount}`,
                    VALUE: x
                  });
                  productVariantCharacteristics.VARIANT_CHARACTERISTICS.push({
                    KEY: `${L5P_MODEL}_${currentCount}`,
                    VALUE: key.substr(key.indexOf(" ") + 1)
                  });
                  productVariantCharacteristics.VARIANT_CHARACTERISTICS.push({
                    KEY: `${L5P_MANUFACTURER}_${currentCount}`,
                    VALUE: key.substr(0, key.indexOf(" ") + 1)
                  });
                  currentCount = ++currentCount;
                }
              });
            }
          }
          if (
            productVariantCharacteristics.VARIANT_CHARACTERISTICS.length > 0
          ) {
            productVariantCharacteristics.ISPRODUCTVARIANTWITHCHARS = "Y";
            productVariantCharacteristics.VARIANT_CHARACTERISTICS.push({
              KEY: "CATALOG_NUMBER",
              VALUE: partNames[0].Value
            });
            productVariantCharacteristics.VARIANT_CHARACTERISTICS.push({
              KEY: "L5P_NUM_CUTS",
              VALUE: --currentCount
            });
          } else {
            productVariantCharacteristics = null;
          }
          this.$store.dispatch(
            "enhancedproduct/setProductVariantCharacteristics",
            {
              productVariantCharacteristics: productVariantCharacteristics
            }
          );
        }
      }
    },
    apply() {
      let _currentOptionIndex = this.currentIndex;
      if (this.isPositionOption) {
        this.$store.dispatch("enhancedBom/unsetBomPartsForPosition", {
          selectedRulesKey: this.selectedRulesKey
        });
        this.$store.dispatch(
          "enhancedproduct/unsetSelectedOptionsForPosition",
          {
            selectedRulesKey: this.selectedRulesKey,
            sectionId: this.sectionId
          }
        );
        for (const [key, value] of Object.entries(
          this.selectedCutoutPositions
        )) {
          this.$store.dispatch(
            "enhancedproduct/updatedSelectedCutoutPosition",
            {
              selectedPosition: value,
              Key: key
            }
          );
          this.$store.dispatch("enhancedBom/setBomPartsForPosition", {
            selectedOption: value
          });
        }
        // this.selectedCutoutPositions = {};
        this.$emit("close");
      } else {
        // this.$emit("apply-selection", this.modalOptions[this.currentIndex]);
        if (this.modalOptions[this.currentIndex]) {
          // if the option is a Part update BOM
          if (this.isPart) {
            this.$store.dispatch("enhancedBom/setBomParts", {
              selectedOption: this.modalOptions[this.currentIndex]
            });
          }

          this.filterCustomPanel();

          // Update the selected option
          this.$store.dispatch("enhancedproduct/updatedSelectedOption", {
            selectedOption: this.modalOptions[this.currentIndex],
            isOptional: this.isOptional
          });
          
          if (
            this.modalOptions[this.currentIndex].RulesKey == "ConfigurationId"
          ) {
            this.$store.dispatch("enhancedproduct/setConfigId", {
              Configurationid: this.modalOptions[this.currentIndex].Value
            });
            // UpdatingSection is only for the case like ConfigurationId where the option updates values in the same section
            this.$store
              .dispatch(
                "enhancedproduct/updatedSectionEnhancedProductOptionValues",
                {
                  SectionId: "1",
                  VariantCode: this.getVariantCode,
                  UpdatingSection: true,
                  OptionIndex: this.optionindexinasection
                }
              )
              .then(() => {
                this.currentIndex = null;
              });
          } else {
            this.preselectIfOnlyOneOption(_currentOptionIndex);
            this.currentIndex = null;
          }
        }
        this.$emit("close");
        // this.currentIndex = null;
      }
    },
    // Loops through all the options in that section and if only one option then it preselects the option
    preselectIfOnlyOneOption(currentIndex) {
      const sectionId = this.modalOptions[currentIndex].EnhancedSectionId;
      if (
        this.getSections &&
        this.getSections[sectionId] &&
        this.getSections[sectionId].sectionOptionValues &&
        this.getSections[sectionId].sectionOptionValues.length > 0
      ) {
        for (
          let i = this.optionindexinasection + 1;
          i < this.getSections[sectionId].sectionOptionValues.length;
          i++
        ) {
          if (
            this.getSections[sectionId].sectionOptionValues[i].Values &&
            this.getSections[sectionId].sectionOptionValues[i].Values.length ===
              1 &&
            !this.getSections[sectionId].sectionOptionValues[i].IsOptional
          ) {
            this.$emit(
              "preselectOption",
              this.getSections[sectionId].sectionOptionValues[i].Values[0]
            );
          } else if (
            this.getSections[sectionId].sectionOptionValues[i]
              .DependentProperty &&
            this.getSections[sectionId].sectionOptionValues[i].DependentProperty
              .length > 0 &&
            !this.getSections[sectionId].sectionOptionValues[i].IsOptional
          ) {
            const filteredOptions = this.filterOptionValuesByDependentProperty(
              this.getSections[sectionId].sectionOptionValues[i]
            );
            if (filteredOptions.length === 1) {
              this.$emit("preselectOption", filteredOptions[0]);
            } else {
              break;
            }
          } else if (
            this.getSections[sectionId].sectionOptionValues[i]
              .DependentProperty &&
            this.getSections[sectionId].sectionOptionValues[i].DependentProperty
              .length > 0 &&
            this.getSections[sectionId].sectionOptionValues[i].IsOptional
          ) {                       
            const filteredOptions = this.filterOptionValuesByDependentProperty(
              this.getSections[sectionId].sectionOptionValues[i]
            );
            if(filteredOptions[0] && filteredOptions[0].DependentPropertyValues[0].Key==="TableShapeId"){
            this.isCustomOptional = true;
            }         
            if(filteredOptions[0] && filteredOptions[0].DependentPropertyValues[0].Key === "TableLengthId" && 
              filteredOptions[0].DependentPropertyValues[0].Value === "1505" ){ 
              this.isCustomOptional = false;
              } else if (filteredOptions[0] && filteredOptions[0].DependentPropertyValues[0].Key === "TableLengthId" && 
              filteredOptions[0].DependentPropertyValues[0].Value != "1505" )
              {
                this.isCustomOptional = true;
              }
            if (filteredOptions.length === 1) {
              if(filteredOptions[0].DependentPropertyValues[0].Key === "TableLengthId" && 
              filteredOptions[0].DependentPropertyValues[0].Value === "1505" ){
                this.$emit("preselectOption", filteredOptions[0]);
              } else if(filteredOptions[0].DependentPropertyValues[0].Key === "TableBaseFinishId") {
                this.$emit("preselectOption", filteredOptions[0]);
              } else {
              break;
              }
            } else {
              break;
            }
          } else {
            break;
          }
        }
      }
    },
    showApplyButton() {
      if (
        this.modalOptions &&
        this.modalOptions[0] &&
        this.modalOptions[0].Position &&
        this.modalOptions[0].Position[0]
      ) {
        return true;
      } else {
        return false;
      }
    },
    selectOption(option, selectedIndex) {
      this.currentIndex = selectedIndex;
      this.isPositionOption = false;
      this.$emit(
        "update",
        this.modalOptions[this.currentIndex].DisplayPosition
      );
      this.apply();
    },
    selectPosition(selectedPosition, rulesKey, optionKey, ischecked) {
      this.isPositionOption = true;
      if (ischecked) {
        this.selectedCutoutPositions = Object.assign(
          this.selectedCutoutPositions,
          selectedPosition
        );
        this.selectedRulesKey = rulesKey;
      } else {
        if (
          selectedPosition[optionKey] &&
          selectedPosition[optionKey].Position.length > 0
        ) {
          this.selectedCutoutPositions = Object.assign(
            this.selectedCutoutPositions,
            selectedPosition
          );
          this.selectedRulesKey = rulesKey;
        } else {
          if (this.selectedCutoutPositions[optionKey]) {
            this.$delete(this.selectedCutoutPositions, optionKey);
          }
        }
      }
    },
    getSelectedIndex(option, index) {
      const _tmpSelectedOptions = this.getSelectedOptions;
      if (this.currentIndex != null && this.currentIndex != undefined) {
        return this.currentIndex;
      } else if (
        _tmpSelectedOptions[option.EnhancedSectionId] &&
        _tmpSelectedOptions[option.EnhancedSectionId][option.RulesKey] &&
        _tmpSelectedOptions[option.EnhancedSectionId][option.RulesKey][
          "Value"
        ] === option.Value
      ) {
        return index;
      } else {
        return null;
      }
    },
    removeOption(option) {
      this.filterCustomPanel(option);
      this.$store.dispatch("enhancedproduct/unsetSelectedOption", option);
      this.$store.dispatch("enhancedBom/unsetBomParts", option.RulesKey);
      this.$emit("close");
    },
    removeCutoutOption(option) {
      this.filterCustomPanel(option);
      this.$store.dispatch("enhancedproduct/unsetSelectedOptionsForPosition", {
        selectedRulesKey: option.RulesKey,
        sectionId: option.EnhancedSectionId
      });
      this.$store.dispatch("enhancedBom/unsetBomPartsForPosition", {
        selectedRulesKey: option.RulesKey
      });
      for (let i = 0; i < option.Position.length; i++) {
        this.$store.dispatch("enhancedproduct/setCutoutPositionValidation", {
          rulesKey: option.RulesKey,
          sectionId: option.EnhancedSectionId,
          checked: false,
          positionKey: option.Position[i].PositionValue,
          value: option.Value
        });
      }
      this.selectedCutoutPositions = {};
      this.$emit("close");
    },
    showClearButton(index) {
      const isFirstOption = 0 === index;
      return isFirstOption && true === this.isOptional;
    },
    filterCustomPanel(option) {
      let enhancedSectionId =
        this.modalOptions[this.currentIndex] &&
        this.modalOptions[this.currentIndex].EnhancedSectionId
          ? this.modalOptions[this.currentIndex].EnhancedSectionId
          : option.EnhancedSectionId;
      let rulesKey =
        this.modalOptions[this.currentIndex] &&
        this.modalOptions[this.currentIndex].RulesKey
          ? this.modalOptions[this.currentIndex].RulesKey
          : option.RulesKey;
      if (this.isOptional) {
        let _tmpVals = this.getSections[enhancedSectionId].sectionOptionValues;
        for (let i = 0; i < _tmpVals.length; i++) {
          if (
            _tmpVals[i].DependentProperty &&
            _tmpVals[i].DependentProperty.includes(rulesKey)
          ) {
            let values = _tmpVals[i].Values;

            for (let j = 0; j < values.length; j++) {
              if (!values[j].Position) {
                this.$store.dispatch(
                  "enhancedproduct/unsetSelectedOption",
                  values[j]
                );
                this.$store.dispatch(
                  "enhancedBom/unsetBomParts",
                  values[j].RulesKey
                );
              }

              if (values[j].Position) {
                this.$store.dispatch(
                  "enhancedproduct/unsetSelectedOptionsForPosition",
                  {
                    selectedRulesKey: values[j].RulesKey,
                    sectionId: values[j].EnhancedSectionId
                  }
                );
                values[j].Position.map(x => {
                  this.$store.dispatch(
                    "enhancedproduct/setCutoutPositionValidation",
                    {
                      rulesKey: values[j].RulesKey,
                      sectionId: values[j].EnhancedSectionId,
                      checked: false,
                      positionKey: x.PositionValue,
                      value: values[j].Value
                    }
                  );
                });
              }

              if (
                this.selectedCutoutPositions &&
                this.selectedCutoutPositions[values[j].Value]
              ) {
                this.$delete(this.selectedCutoutPositions, values[j].Value);
                for (const [key, value] of Object.entries(
                  this.selectedCutoutPositions
                )) {
                  this.$store.dispatch(
                    "enhancedproduct/updatedSelectedCutoutPosition",
                    {
                      selectedPosition: value,
                      Key: key
                    }
                  );
                  this.$store.dispatch("enhancedBom/setBomPartsForPosition", {
                    selectedOption: value
                  });
                }
                this.$store.dispatch(
                  "enhancedBom/unsetBomParts",
                  values[j].Value
                );
              }
            }
          }
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.sidebar-panel-content {
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.2s ease;
}

.slide-enter,
.slide-leave-to {
  transform: translateY(100%);
  transition: all 150ms ease-in 0.1s;
  @include media-breakpoint-up(md) {
    transform: translateX(100%);
  }
}

.sidebar-backdrop {
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  cursor: pointer;
  z-index: 1001;
}

.sidebar-panel {
  overflow-y: auto;
  background-color: #fff;
  position: fixed;
  right: 0;
  top: 0;
  height: 100vh;
  z-index: 10001;
  padding: 20px;
  width: 100%;
  box-shadow: 0px 1px 9px 1px rgba(0, 0, 0, 0.15);

  @include media-breakpoint-up(md) {
    width: 50%;
    padding: 30px;
  }
  @include media-breakpoint-up(lg) {
    width: 440px;
    padding: 40px;
  }
}

.close-btn-container {
  display: block;
  text-align: right;
  position: relative;
  margin: 7px 0 37px 0;
  .material-icons {
    color: rgb(35, 60, 63);
    font-size: 36px;
    font-weight: normal;
    cursor: pointer;
  }
}

.product-configuration-container {
  display: block;
  text-align: left;
  padding-bottom: 100px;

  .product-configuration-title {
    color: rgb(51, 51, 51);
    font-family: $font-weight-medium;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.25px;
    margin: 0 0 20px 0;
  }
}

.apply-selection-btn {
  position: fixed;
  bottom: 10px;
  transform: translate(-50%, -50%);
  margin: 0 0 10px 0;
  background: rgb(37, 192, 208);
  border: 0px;
  box-shadow: 0px 2px 11px 5px rgba(0, 0, 0, 0.1);
  padding: 12px 30px 10px;
  color: #fff;
  text-transform: uppercase;
  font-family: $font-weight-bold;
  font-size: 16px;
  letter-spacing: 0.75px;
  min-width: 220px;
  @include media-breakpoint-up(md) {
    bottom: 10px;
  }
}

.ie-11 .apply-selection-btn {
  @include media-breakpoint-down(md) {
    transform: none;
    left: 50%;
    margin-left: -110px;
  }

  @include media-breakpoint-up(md) {
    transform: translate(35%, -50%);
  }
}

.position {
  &__header {
    margin-bottom: 30px;

    &__placement {
      font-family: $font-family-sans-serif-medium;
      font-size: 14px;
      letter-spacing: 1px;
      line-height: 24px;
      text-transform: uppercase;
      color: $gray-dark;
      margin-bottom: 10px;
    }

    &__image {
      position: relative;
      height: 150px;
      // border: 1px solid $gray;

      .header-image {
        position: absolute;
        width: 100%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}

.clearBtn {
  color: rgb(37, 192, 208);
  font-size: 16px;
  font-family: $font-family-sans-serif-regular;
  font-weight: 600;
  text-decoration: underline;
  letter-spacing: 0.25px;
  cursor: pointer;
  text-align: right;
  margin-bottom: 10px;
}
</style>
